import { create } from '@thoughtspot/logger';
import { DispatchChartInteractionType, } from '@thoughtspot/ts-chart-sdk';
import { getIframeAdjustedCoords } from '../common/utils/helper';
const logger = create('chart-to-ts > dispatch-chart-interaction > trigger');
const interactionTypeToDOMEvent = {
    [DispatchChartInteractionType.PointerDown]: 'mousedown',
};
export const handleTriggerOnParent = (type, eventPayload, iFrameWindow) => {
    const { clientX: adjustedX, clientY: adjustedY } = getIframeAdjustedCoords(iFrameWindow, eventPayload.event.clientX, eventPayload.event.clientY);
    const domEventName = interactionTypeToDOMEvent[type] || type.toLowerCase();
    const syntheticEvent = new PointerEvent(domEventName, {
        clientX: adjustedX,
        clientY: adjustedY,
        bubbles: true,
        cancelable: true,
    });
    const targetElement = document.elementFromPoint(adjustedX, adjustedY);
    if (targetElement) {
        targetElement.dispatchEvent(syntheticEvent);
    }
    else {
        logger.warn(`No target element found at (${adjustedX}, ${adjustedY})`);
    }
    logger.info(`Dispatched synthetic ${domEventName} at (${adjustedX}, ${adjustedY})`, { targetId: eventPayload.targetId });
};
//# sourceMappingURL=trigger-event.js.map